import { render, staticRenderFns } from "./OrderActionRefundShipping.vue?vue&type=template&id=6815a29e&"
import script from "./OrderActionRefundShipping.vue?vue&type=script&lang=ts&"
export * from "./OrderActionRefundShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports